import { create } from 'zustand';

type DrawerTab = 'workflow' | 'subagents';

interface TraceDrawerState {
  isOpen: boolean;
  traceId: string | undefined;
  activeTab: DrawerTab;
  open: (traceId: string) => void;
  openTab: (tab: DrawerTab, traceId?: string) => void;
  close: () => void;
  toggle: () => void;
  setActiveTab: (tab: DrawerTab) => void;
}

/**
 * Zustand store for trace drawer visibility state.
 * Separate from URL state to avoid polluting navigation history
 * for transient UI state.
 */
export const useTraceDrawerStore = create<TraceDrawerState>((set, get) => ({
  isOpen: false,
  traceId: undefined,
  activeTab: 'workflow',
  open: (traceId: string) =>
    set({ isOpen: true, traceId, activeTab: 'workflow' }),
  openTab: (tab: DrawerTab, traceId?: string) => {
    const state = get();
    set({
      isOpen: true,
      activeTab: tab,
      traceId: traceId ?? state.traceId,
    });
  },
  close: () => set({ isOpen: false, traceId: undefined }),
  toggle: () => {
    const { isOpen } = get();
    if (isOpen) {
      set({ isOpen: false });
    }
  },
  setActiveTab: (tab: DrawerTab) => set({ activeTab: tab }),
}));
